module.exports = __webpack_public_path__ + "static/media/icon_reilu5g_red.771deab2.svg";